export default "__VITE_ASSET__CxiQebVE__"